const SkeletonLoader = ({
  width = '100%',
  height = '100%',
  borderRadius = '4px'
}) => {
  return (
    <div
      className='skeleton-loader'
      style={{
        width,
        height,
        borderRadius
      }}
    />
  );
};

export default SkeletonLoader;
